// extracted by mini-css-extract-plugin
export var blogLink = "blog-module--blog-link--152bs";
export var blogDate = "blog-module--blog-date--3MLTp";